import { render, staticRenderFns } from "./12.vue?vue&type=template&id=4cee712f&scoped=true&"
var script = {}
import style0 from "./12.vue?vue&type=style&index=0&id=4cee712f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cee712f",
  null
  
)

export default component.exports